import Typography from '@/components/shared/typography/typography.component';
import { CarDetailsType, sourceScreenTypes } from '@/types';
import Image from 'next/image';
import { HelpIconBlack, PriceBenefitsGif } from 'public/Images';
import { FC, useState } from 'react';
import PriceBreakdownModal from './price-breakdown-modal.component';
import PriceBreakdownBottomsheet from './price-breakdown-bottomsheet.component';
import { TFunction } from 'i18next';
import myImageLoader from '@/image.local.loader';
import { numberWithCommas } from '@/utils';
import { useAnalytics } from '@/integrations';

const PriceBreakdown: FC<{
    carDetails: CarDetailsType;
    IS_DESKTOP: boolean;
    t: TFunction<'translation', undefined>;
}> = ({ carDetails, IS_DESKTOP, t }) => {
    const { trackEvent } = useAnalytics();
    const [openPriceBreakdownModal, setOpenPriceBreakdownModal] =
        useState(false);
    return (
        <>
            <div
                onClick={() => {
                    setOpenPriceBreakdownModal(true);
                    trackEvent('Action: Click On Price Breakdown', {
                        carName: carDetails.sfVehicleName,
                        make: carDetails.make,
                        model: carDetails.model,
                        year: carDetails.year,
                        kilometers: carDetails.kilometers,
                        trim: carDetails.trim?.en,
                        transmission: carDetails.transmission,
                        color: carDetails.color,
                        price: carDetails.sylndrSellingPrice,
                        bodyStyle: carDetails.bodyStyle,
                        newlyAdded:
                            carDetails.isNewlyAdded &&
                            !(
                                carDetails.isReserved ||
                                carDetails.isPurchaseInProgress
                            ),
                        sourceScreen: sourceScreenTypes.CAR_PROFILE,
                    });
                }}
                className="flex items-center justify-between gap-2 bg-primary-25 p-3 rounded-xl cursor-pointer"
            >
                <div className="w-9 h-9 flex items-center justify-center bg-primary-100 rounded-full">
                    <img
                        className="rounded w-6 h-6"
                        src={myImageLoader({
                            src: PriceBenefitsGif.src,
                            width: 25,
                            height: 25,
                            quality: 80,
                        })}
                        alt="car image"
                    />
                </div>
                <div className="w-[calc(100%-80px)]">
                    <Typography
                        className="!text-primary-700 h-9 line-clamp-2"
                        variant="caption"
                    >
                        {t('priceBreakdownTextpart1')}
                        <span className="line-through font-bold">
                            {t('EGP')}{' '}
                            {numberWithCommas(
                                +carDetails.registrationFees || 0
                            )}
                        </span>
                        {' - '}
                        {t('priceBreakdownTextpart2')}
                        <span className="line-through font-bold">
                            {t('included')}
                        </span>{' '}
                        - {t('priceBreakdownTextpart3')}
                        <span className="line-through font-bold">
                            {t('EGP')} {numberWithCommas(10000)}
                        </span>
                    </Typography>
                </div>
                <Image
                    src={HelpIconBlack}
                    alt="help-circle"
                    className="w-[18px] h-[18px]"
                />
            </div>
            {IS_DESKTOP ? (
                <PriceBreakdownModal
                    carDetails={carDetails}
                    openPriceBreakdownModal={openPriceBreakdownModal}
                    setOpen={setOpenPriceBreakdownModal}
                    t={t}
                />
            ) : (
                <PriceBreakdownBottomsheet
                    carDetails={carDetails}
                    openPriceBreakdownModal={openPriceBreakdownModal}
                    setOpen={setOpenPriceBreakdownModal}
                    t={t}
                />
            )}
        </>
    );
};

export default PriceBreakdown;
